<template>
<div class="modal fade" id="analyseModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Analyse Financière</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" id="close4" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div>
                    <ol>
                        <li>
                            <div class="form-group">
                                <label for="">Bilan Comptable (3 dernières années)</label>
                                <input type="file" class="form-control" name="file" id="file" @change="bilanChange">
                            </div>
                        </li>
                        <li>
                            <div class="form-group">
                                <label for="">Compte de Résultat (3 dernières années)</label>
                                <input type="file" class="form-control" name="file" id="file" @change="resultatChange">
                            </div>
                        </li>
                        <li>
                            <div class="form-group">
                                <label for="">Flux de Trésorerie (3 dernières années)</label>
                                <input type="file" class="form-control" name="file" id="file" @change="tresoChange">
                            </div>
                        </li>
                        <li>
                            <div class="form-group">
                                <label for="">Ratios Financiers Clés</label>
                                <input type="file" class="form-control" name="file" id="file" @change="ratiosChange">
                            </div>
                        </li>
                        <li>
                            <div class="form-group">
                                <label for="">Analyse des Performances et Tendances</label>
                                <input type="file" class="form-control" name="file" id="file" @change="perfChange">
                            </div>
                        </li>
                    </ol>
                </div>
            </div>
            <div class="modal-footer">
                <div class="form-group">
                    <button class="btn btn-success" @click="submit" data-bs-dismiss="modal" type="submit"><i class="bx bi-save"></i> ENREGISTRER</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from "axios";
    export default{
        name:'AnalyseComponent',
        props:{
            dossier:{
                'type':Object,
                'required':true,
            }
        },
        data(){
            return {
                bilan:null,
                compte_resultat:null,
                flux_treso:null,
                ratios:null,
                performances_tendances:null,
            }
        },
        methods:{
            bilanChange(event){
                this.bilan = event.target.files[0];
            },
            resultatChange(event){
                this.compte_resultat = event.target.files[0];
            },
            tresoChange(event){
                this.flux_treso = event.target.files[0];
            },
            ratiosChange(event){
                this.ratios = event.target.files[0];
            },
            perfChange(event){
                this.performances_tendances = event.target.files[0];
            },
            submit(){
                    let loader = this.$loading.show({
                        container: this.fullPage ? null : this.$refs.formContainer,
                        canCancel: false,
                    });
                    let form = new FormData();
                    if(this.bilan!=null){
                        form.append("bilan",this.bilan);
                    }
                    if(this.compte_resultat!=null){
                        form.append("compte_resultat",this.compte_resultat);
                    }
                    if(this.flux_treso!=null){
                        form.append("flux_treso",this.flux_treso);
                    }
                    if(this.ratios!=null){
                        form.append("ratios",this.ratios);
                    }
                    if(this.performances_tendances!=null){
                        form.append("performances_tendances",this.performances_tendances);
                    }
                    delete this.dossier.institution;
                    form.append("dossier",JSON.stringify(this.dossier));
                    axios.post(this.path+'cga/dimf/save',form,{
                        headers:{
                            'Accept':'multipart/form-data'
                        }
                    })
                    .then((res)=>{
                        console.log(res)
                        this.$emit('success');
                    })
                    .catch((err)=>{
                        this.$emit('error')
                        console.log(err)
                    })
                    .finally(()=>loader.hide())
                
            }
        },
        computed:{
        },
        watch:{
            dossier(newValue,oldValue){
                console.log(oldValue)
                console.log(newValue)
            }
        },
        mounted(){
            
        }
    }

</script>

<style scoped>


</style>